import React, { useEffect, useState } from "react";
import HeroImage from "../Assets/112.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import AppointmentModal from "./AppointmentModal";
import "../Styles/Hero.css";

function Hero() {
  const [goUp, setGoUp] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.scrollY > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);

  return (
    <div className="section-container">
      <div className="hero-section">
        <div className="text-section">
          <p className="text-headline">🧠 Brain Health Matters</p>
          <h2 className="text-title">
            Find your Neurologist and make an Appointments
          </h2>
          <p className="text-descritpion">
            Consult with expert neurologists for brain and nervous system care,
            online prescriptions, refills and medical notes within minutes.
            Specialized neurology services at NeuroCare Clinic.
          </p>
          <button
            className="text-appointment-btn"
            type="button"
            onClick={openModal}
          >
            <FontAwesomeIcon icon={faCalendarCheck} /> Book Appointment
          </button>
        </div>

        <div className="hero-image-section">
          <img className="hero-image1" src={HeroImage} alt="Neurology care" />
        </div>
      </div>

      <div
        onClick={scrollToTop}
        className={`scroll-up ${goUp ? "show-scroll" : ""}`}
      >
        <FontAwesomeIcon icon={faAngleUp} />
      </div>

      <AppointmentModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}

export default Hero;
